<div class="preview-shell" [attr.data-theme]="meta.theme">
  <header class="preview-header">
    <div class="preview-title">
      <span class="doc-badge">
        <mat-icon>{{ meta.icon }}</mat-icon>
      </span>
      <div class="title-text">
        <span class="doc-label">{{ meta.label }}</span>
        <span class="doc-sub">
          Probate <strong>{{ data.probateId }}</strong>
          <ng-container *ngIf="data.deceasedName"> &middot; {{ data.deceasedName }}</ng-container>
        </span>
      </div>
    </div>

    <div class="preview-actions">
      <button mat-icon-button class="action-btn" (click)="openInNewTab()"
              [disabled]="loading || !!errorMessage" matTooltip="Open in new tab">
        <mat-icon>open_in_new</mat-icon>
      </button>
      <button mat-icon-button class="action-btn" (click)="download()"
              [disabled]="loading || !!errorMessage" matTooltip="Download">
        <mat-icon>download</mat-icon>
      </button>
      <button mat-icon-button class="action-btn close-btn" (click)="close()" matTooltip="Close">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </header>

  <section class="preview-body">
    <div *ngIf="loading" class="preview-state">
      <mat-spinner diameter="40"></mat-spinner>
      <span class="state-text">Loading {{ meta.label }}…</span>
    </div>

    <div *ngIf="!loading && errorMessage" class="preview-state error">
      <mat-icon class="state-icon">error_outline</mat-icon>
      <span class="state-text">{{ errorMessage }}</span>
    </div>

    <iframe *ngIf="!loading && !errorMessage && pdfUrl"
            [src]="pdfUrl"
            class="preview-frame"
            title="PDF preview"></iframe>
  </section>
</div>
